export default "__VITE_ASSET__b8fe4675__"